module.exports = __webpack_public_path__ + "static/media/天錯之合.1eee582a.jpg";